import React, { useState } from "react";
import moment from "moment";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";

import { fileUrl, endPoints } from "../../../config";
import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel"; 
import { GetPdfHtml } from "../../common/CampaignPdfHtml";

import { axiosInstnace as Axios } from "../../../util/util";

//Generate the pdf for campaign
const generatePdf = async (campaign) => {
  const input = document.getElementById("divToPrint");
  input.style.display = "block";
  var opt = {
    filename: `${campaign._id}.pdf`,
  };
  await html2pdf().from(input).set(opt).save();
  input.style.display = "none";
  // html2canvas(input)
  //   .then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(imgData, 'JPEG', 0, 0);
  //     pdf.save(`${campaign._id}.pdf`);
  //     input.style.display= 'none';
  //   });
};

//Show campaign info
const UploadRequestedAudio = (props) => {
  console.log("Veiw Campaing");
  let { a } = props.location.state;
  let campaign = a;

  const [audioUrl, handleAudioUrl] = useState(campaign.audioUrl);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));

  //Download Audio file
  const downladAudio = (audioUrl) => {
    var campaignName = campaign.name;
    var date = moment(campaign.startDate).format("DD-MM-YYYY");
    var originalFileName = campaign.fileName;
    var formatedFilename =
      campaignName.trim() +
      "_" +
      date +
      "_" +
      campaign.station +
      "_" +
      campaign._id +
      "_" +
      campaign.audioDuration + " Seconds" +
      "_" +
      originalFileName;
    console.log(formatedFilename);
    try {
      const fileName = audioUrl.split("/");
      console.log(fileName);
      Axios.get(endPoints.downloadAudio, {
        responseType: "blob",
        params: { file: audioUrl, download: formatedFilename },
      }).then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", formatedFilename);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.log("Error while download audio :" + error);
    }
  };

  //Audio round off calculation
  const audioRoundOff = (bytes, decimals = 2) => {
    console.log("calculation for audion length");
    var sizes = ["Bytes", "KB", "MB", "GB"];
    if (bytes == 0) return "0 bytes";
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed()) + " " + sizes[i];
  };

  let kycDetails = campaign && campaign.kycDetails.length > 0 ? campaign.kycDetails[0] : null;
  let userDetails = campaign && campaign.userDetails.length > 0 ? campaign.userDetails[0] : null;
  console.log(campaign.userDetails);
  return (
    <div>
      <div className="dashboardContainer">
      <HeaderAdminpanel/>
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section id="dashboard-rightContainer" className="dashboard-manageSales brands-head">
            <div className="container-head print_head">
              <div className="dashboard-breadcrumb">
                Audio Management | Audio Request List |
                <span className="blue_camp"> Upload Audio</span>
              </div>
            </div>
            <div className="camplist_detail_wrapper">
              <div className="camplist_detail_left">
                <div className="camplist_left_inner"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <GetPdfHtml campaign={campaign} />
    </div>
  );
};

export default UploadRequestedAudio;



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/UploadAudiolist.js